import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "matching-list page-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MatchingListDesktop = _resolveComponent("MatchingListDesktop")!
  const _component_MatchingListMobile = _resolveComponent("MatchingListMobile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$screen.mdUp)
      ? (_openBlock(), _createBlock(_component_MatchingListDesktop, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.$screen.smDown)
      ? (_openBlock(), _createBlock(_component_MatchingListMobile, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}